module.exports = __webpack_public_path__ + "static/media/healthy-ireland.0f9fd184.png";